import React from 'react';
import Card from 'react-bootstrap/Card';
import { Button } from "react-bootstrap";

const infoPanelStyle = {
    position: "absolute",
    top: "54px",
    margin: "1em",
    zIndex: 100,
    width:"350px",
}
const InfoPanel = ({features, deleteSelected}) => {
    const featureIdArr = features.map(e => e.properties["spec_id"]);
    const featureType = features[0].properties["type_name"];
    return (
        <Card style={infoPanelStyle}>
            <Card.Body>
                <Card.Title>Auswahl des Analysebereichs</Card.Title>
                <Card.Text>{featureIdArr.length} Feature(s) ausgewählt. </Card.Text>
                <Card.Text>Einheitentyp: {featureType}</Card.Text>
                <Button
                    variant="outline-danger"
                    onClick={()=> deleteSelected()}
                >
                    Auswahl entfernen
                </Button>
            </Card.Body>
            <Card.Footer>
                <small className="text-muted">Datenstand 2024</small>
            </Card.Footer>
        </Card>)
}

export default InfoPanel;
